import SpinLoader from '@Utils/loaders/spin'

import useBatchImportDispatch from '../../hooks/useBatchImportDispatch'
import useBatchImportState from '../../hooks/useBatchImportState'
import MapFields from '../match-field/MapFields'

function ImportMapFields(): JSX.Element {
  const {
    requiredNotSelected = [],
    options = [],
    allSelected = [],
    matchedProperties = [],
    matchedSelected = [],
    unmatchedProperties = [],
    unmatchedSelected = [],
    isCreateImportLoading,
  } = useBatchImportState()

  const {
    setMatchedSelected,
    removeMatchedSelected,
    setUnmatchedSelected,
    removeUnmatchedSelected,
    setCancelClicked,
    createImport,
  } = useBatchImportDispatch()

  const handleCancelImport = (): void => {
    setCancelClicked(true)
  }

  const handleCreateImport = async (): Promise<void> => {
    await createImport()
  }

  return (
    <div className="flex flex-col">
      <MapFields
        state={{
          requiredNotSelected,
          options,
          allSelected,
          matchedProperties,
          matchedSelected,
          unmatchedProperties,
          unmatchedSelected,
        }}
        actions={{
          setMatchedSelected,
          removeMatchedSelected,
          setUnmatchedSelected,
          removeUnmatchedSelected,
        }}
      />
      <div className="flex flex-row justify-end border-b border-solid border-gray-200 mt-4 pb-4">
        <button
          onClick={handleCancelImport}
          className="px-4 py-2 cursor-pointer select-none font-medium text-sm text-gray-500 active:text-gray-700"
        >
          Cancel import
        </button>
        <button
          onClick={handleCreateImport}
          className={
            'border border-solid font-medium text-xs md:text-sm px-4 py-2 text-white-100 rounded-lg shadow-sm border-primary-600 bg-primary-600 active:bg-primary-700 disabled:opacity-75 flex items-center'
          }
          disabled={requiredNotSelected.length > 0 || isCreateImportLoading}
          type="button"
        >
          {isCreateImportLoading ? (
            <span
              className={`-ml-3 mr-1 [&>*]:!inline [&>*]:!ml-2 [&>*]:!mr-0 [&>*]:!w-[16px] [&>*]:!h-[16px] [&>*]:!opacity-70 [&>*]:!bg-transparent [&>*>*]:!stroke-white-100`}
            >
              <SpinLoader />
            </span>
          ) : (
            <></>
          )}
          Complete Import
        </button>
      </div>
    </div>
  )
}

export default ImportMapFields
